export const PACKAGES_GET_REQUEST = "@packages.get.request";
export const PACKAGES_GET_SUCCESS = "@packages.get.success";
export const PACKAGES_GET_FAIL = "@packages.get.failure";

export const PACKAGE_LOAD_REQUEST = "@package.load.request";
export const PACKAGE_LOAD_SUCCESS = "@package.load.success";
export const PACKAGE_LOAD_FAIL = "@package.load.failure";

export const PACKAGE_CREATE_REQUEST = "@package.create.request";
export const PACKAGE_CREATE_SUCCESS = "@package.create.success";
export const PACKAGE_CREATE_FAIL = "@package.create.failure";
export const PACKAGE_CREATE_DONE = "@package.create.done";

export const PACKAGE_UPDATE_REQUEST = "@package.update.request";
export const PACKAGE_UPDATE_SUCCESS = "@package.update.success";
export const PACKAGE_UPDATE_FAIL = "@package.update.failure";
export const PACKAGE_UPDATE_DONE = "@package.update.done";
